
var constants = require('../../domain/constants.js');
var stringUtil = require('../../string/stringUtil.js');
var rmsApiProxyRetry = require('../../api/rmsApiProxyRetry.js');
var logger = require('../../logger/logger');

module.exports.performRefund = function(sale, amount)
{
    var refundRequest = {};
    refundRequest.storefrontId =  sale.storefrontId;
    refundRequest.amount = amount * 1;
    this.enrichRefundRequestWithTransactionId(refundRequest, sale);
   
    var resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/refunds`;
    return rmsApiProxyRetry.post(resource, refundRequest)
            .then(result =>
            {
                return Promise.resolve(result);
            }, error =>
            {
                logger.warn(`Error occurred while executing a refund`, {}, error, "Stripe");
                return Promise.reject(error);
            });
}


module.exports.enrichRefundRequestWithTransactionId = function(refundRequest, sale)
{
    var processor = "Stripe";
    var stripeTransaction = null;
    sale.receiptLines.forEach (r =>
        {
            if (r.paymentMethod != constants.PaymentMethodVenuePaid)
                return;

            var line = JSON.parse(r.line);
            
            if (!stringUtil.areStringSame(line.processor, processor))
                return;

            stripeTransaction = JSON.parse(line.rawResult);
        });


    if (stripeTransaction == null || 
        stripeTransaction.paymentIntent == null || 
        stringUtil.isStringNullOrEmpty(stripeTransaction.paymentIntent.id))
        return null;

    refundRequest.processor = processor;
    refundRequest.transactionId = stripeTransaction.paymentIntent.id;
}